// import $models from '..'
import schema from './schema'

export default {
  modelActions: {},
  modelGetters: {},
  staticGetters: {
  },
  staticActions: {
    doSomethingFancy() {
      console.log("doSomethingFancy");
    },
  },
  schema:  schema
};
